import uniq from 'lodash/uniq';

export const isUniqueOption = (data, index) =>
  uniq(data.variants.map((variant) => variant[`option${index}`])).length === 1;

export const uniqueName = (data, selectedVariant, separator = ' / ') => {
  const getOption = (index) => selectedVariant[`option${index}`];

  const showOption1 = !isUniqueOption(data, 1);
  const showOption2 = !isUniqueOption(data, 2);
  const showOption3 = !isUniqueOption(data, 3);
  const title = [];

  if (showOption1) {
    const option = getOption(1);

    if (option) {
      title.push(option);
    }
  }

  if (showOption2) {
    const option = getOption(2);

    if (option) {
      title.push(option);
    }
  }

  if (showOption3) {
    const option = getOption(3);

    if (option) {
      title.push(option);
    }
  }

  return title.join(separator);
};

export const sendSelectEvent = (id, handle, title) => {
  const event = new CustomEvent('theme:variant:selected', {
    detail: {
      id: parseInt(id, 10),
      handle,
      title,
    },
  });

  document.dispatchEvent(event);
};

export default {
  isUniqueOption,
  uniqueName,
  sendSelectEvent,
};
